import { v4 as uuidv4 } from 'uuid'
import { put, race, take } from 'redux-saga/effects'

export function* confirmSaga(payload) {
  try {
    const confirmUUID = uuidv4()

    yield put({
      type: 'MODAL/SHOW',
      payload: {
        modalType: payload.modalType || 'confirmation',
        UUID: confirmUUID,
        modalProps: { ...payload, UUID: confirmUUID },
      },
    })

    const { confirmationResolve, confirmationCancel } = yield race({
      confirmationResolve: take('MODAL/CONFIRM_' + confirmUUID),
      confirmationCancel: take('MODAL/CANCEL_' + confirmUUID),
    })

    if (confirmationCancel) {
      yield put({ type: 'MODAL/HIDE', payload: { UUID: confirmUUID } })
    }

    return [Boolean(confirmationResolve), confirmUUID]
  } catch (error) {
    console.logXHR(error)
  }
}
